var render, staticRenderFns
import script from "./badge.vue?vue&type=script&lang=js&"
export * from "./badge.vue?vue&type=script&lang=js&"
import style0 from "./badge.vue?vue&type=style&index=0&id=43fdbcae&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports